import { CREATE_LUNCH_PULL_BY_ADMIN } from "@/GraphQL/Mutation";
import { GET_ALL_USER } from "@/GraphQL/Queries";
import CreateLayout from "@/shared/components/Layouts/CreateLayout";
import ModalLayout from "@/shared/components/Layouts/ModalLayout";
import { findOption } from "@/utils/helpers";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function LunchModal({
  modal,
  toggle,
  userId,
  defaultData,
  refetch,
}) {
  const LoadAllUsers = useQuery(GET_ALL_USER);
  const userOptions =
    LoadAllUsers?.data?.getUser?.map((user) => {
      return {
        label: user?.name,
        value: user?.id,
      };
    }) || "";

  const pullOption = [
    {
      label: "No",
      value: false,
    },
    {
      label: "Yes",
      value: true,
    },
  ];
  const [createLunchPullByAdmin, { loading: creating }] = useMutation(
    CREATE_LUNCH_PULL_BY_ADMIN
  );
  const handleSubmit = async (formData) => {
    const variables = {
      lunch_date: moment(formData?.lunch_date).format("YYYY-MM-DD"),
      has_lunch: true,
      user_id: Number(formData.user_id?.value),
    };

    try {
      const result = await createLunchPullByAdmin({ variables });

      const response = result?.data?.createLunchPullByAdmin;

      if (response?.result_code === "000") {
        await Swal.fire("✅ Success", "Lunch created successfully!", "success");
        refetch();
        toggle(); // close modal
      } else {
        await Swal.fire(
          "⚠️ Failed",
          response?.status || "Failed to create lunch.",
          "error"
        );
        toggle();
      }
    } catch (err) {
      console.error("❌ Error:", err);
      await Swal.fire(
        "❌ Error",
        "Something went wrong. Please try again.",
        "error"
      );
    }
  };
  // const handleSubmit = async (formData) => {
  //   const variables = {
  //     lunch_date: moment(formData?.lunch_date).format("YYYY-MM-DD"),
  //     has_lunch: formData?.has_lunch?.value,
  //     user_id: Number(formData.user_id?.value),
  //   };

  //   try {
  //     const result = await createLunchPullByAdmin({
  //       variables,
  //     });

  //     if (result?.data?.createLunchPullByAdmin?.result_code === "000") {
  //       toast.success("Lunch Create successfully!");
  //       toggle();
  //     }
  //     toast.error(`${result?.data?.createLunchPullByAdmin?.status}`);
  //     toggle();
  //   } catch (err) {
  //     console.error("Error:", err);
  //     toast.error("Failed .");
  //   }
  // };
  const forms = [
    {
      name: "user_id",
      label: "Select User",
      placeholder: "Select User",
      type: "select",
      deviceSize: 12,
      options: userOptions,
      defaultValue: defaultData?.id
        ? findOption(userOptions, defaultData?.user_id)
        : "",
      disabled: true,
      rules: () => ({
        required: "This is a required field",
      }),
    },
    {
      name: "lunch_date",
      label: "Select Date",
      placeholder: "Select Date",
      type: "date",
      minDate: new Date(),
      rules: () => ({
        required: "This is a required field",
      }),
      defaultValue: "",
    },
  ];
  return (
    <ModalLayout
      style={{ maxWidth: "500px", width: "100%" }}
      className="modal-sm-custom"
      modal={modal}
      toggle={toggle}
    >
      <CreateLayout
        onSubmit={handleSubmit}
        forms={forms}
        toggle={toggle}
        loading={creating}
        // loader={creating}
        // submitText={defaultData?.id ? "Update" : "Add"}
      />
    </ModalLayout>
  );
}
